import { render, staticRenderFns } from "./DischargeCertificate.vue?vue&type=template&id=e0abf4a2&scoped=true"
import script from "./DischargeCertificate.vue?vue&type=script&lang=js"
export * from "./DischargeCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0abf4a2",
  null
  
)

export default component.exports